module.exports = __webpack_public_path__ + "static/media/support.9540dce6.svg";